module.exports = __webpack_public_path__ + "static/media/aboutUs-Researcher.7175d592.png";